import { useFilterContent } from "@/Hooks/FilterContent/useFilterContent";
import { useState } from "react";
import { Link } from "react-router-dom";

type Props = {
  longDescription: string;
  cTab2Content: string;
};

export const Table = ({
  longDescription,
  cTab2Content,
}: Props): JSX.Element => {
  //Activar y Desactibar para ver la descripción o espesificaciones
  const [MView, setMView] = useState<boolean>(true);

  //console.log("longDescription", longDescription);

  /**************************************/

  /******> Description or specification <******/
  const ActiveMView = (act: boolean) => {
    setMView(act);
  };

  /**************************************/
  const parser = new DOMParser();
  const doc = parser.parseFromString(longDescription, "text/html");
  //const docElement: Element[] = Array.from(doc.body.children);
  //const filterContent = useFilterContent(docElement);


  return (
    <>
      <ul className="ps-tab-list">
        <li className={MView ? "active" : ""}>
          <Link to={""} onClick={() => ActiveMView(true)}>
            Descripción
          </Link>
        </li>
        <li className={!MView ? "active" : ""}>
          <Link to={""} onClick={() => ActiveMView(false)}>
            Especificaciones
          </Link>
        </li>
      </ul>
      <div className="ps-tabs">
        <div className={`ps-tab ${MView ? "active" : ""} `}>
          <div className="ps-document text-justify">
            {
              <span
                dangerouslySetInnerHTML={{ __html: doc.body.innerHTML }}
                style={{ fontSize: "1.8rem" }}
              />
            }
          </div>
        </div>
        <div className={`ps-tab ${!MView ? "active" : ""} `}>
          <div className="table-responsive">
            <div dangerouslySetInnerHTML={{ __html: cTab2Content }} />
          </div>
        </div>
      </div>
    </>
  );
};
